import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { dataHooks } from '../../../dataHooks';
import { AppContextProvider } from '../../AppLoader';
import { ButtonWithLoader } from '../../ButtonWithLoader/ButtonWithLoader';
import { EnforcementCard } from '../PremiumUsers2FaEnforcement/EnforcementCard';
import { VerificationState } from '../VerifyButton';
import { DealerOfferCard } from './DealerOfferCard';

/** redesigned "change account email" step (wix-2025): new email twice, then a code. */
export const ChangeAccountEmailRedesign: React.FC = observer(() => {
  const {
    rootStore: {
      changeAccountEmailStore: store,
      navigationStore,
      displayStore: { preset },
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();
  const isDisabled =
    store.isSubmmited ||
    !store.emailInput.isValid ||
    !store.confirmEmailInput.isValid ||
    store.emailInput.value.toLowerCase() !==
      store.confirmEmailInput.value.toLowerCase();
  const onContinue = () => !isDisabled && store.sendConfirmationCode();

  return (
    <DealerOfferCard
      title={t('post.login.change.account.email.title')}
      subtitle={t('post.login.change.account.email.subtitle')}
      showBackButton={store.verificationState !== VerificationState.Verified}
      backButtonCallback={() => {
        store.clean();
        navigationStore.goBack();
      }}
      primaryButton={
        <ButtonWithLoader
          skin={preset.buttonDesign?.skin ?? 'standard'}
          onClick={onContinue}
          disabled={isDisabled}
          showLoader={store.isSubmmited}
        >
          {t('post.login.continue')}
        </ButtonWithLoader>
      }
    >
      <Box direction="vertical" width="100%" gap={3}>
        <EnforcementCard.Input
          field={store.emailInput}
          label={t('post.login.change.account.email.new.email')}
          dataHook={dataHooks.postLogin.changeAccountEmail.emailInput}
          type="email"
          autocomplete="email"
          autoFocus
          onBlur={() => store.updateFieldMatchError()}
          onFocus={() => store.clearFieldErrors(store.confirmEmailInput)}
        />
        <EnforcementCard.Input
          field={store.confirmEmailInput}
          label={t('post.login.change.account.email.reenter.new.email')}
          dataHook={dataHooks.postLogin.changeAccountEmail.confirmEmailInput}
          type="email"
          autocomplete="email"
          onBlur={() => store.updateFieldMatchError()}
          onEnterPressed={onContinue}
          disablePaste
        />
      </Box>
    </DealerOfferCard>
  );
});
